<template>
  <v-expansion-panel id="cell-select" v-if="item.cells || showUserCells" v-model="expanded" class="mx-3">
    <v-expansion-panel-content>
      <div slot="header" v-show="expanded === null">
        {{ t('Cell') }}:
        <span v-for="(c, i) in selected" :key="i">
          <span v-if="i > 0">/</span>
          <v-chip :selected="i == last"> {{ c.desc || c.name }} </v-chip>
        </span>
      </div>
      <div slot="header" v-show="expanded === 0">{{ t('Select a group below') }}:</div>

      <v-card>
        <v-card-text>
          <!-- L/AL multi-cell flat selector -->
          <div v-if="showUserCells">
            {{ t('Cell') }}:
            <v-chip
              v-for="name in userCells"
              :key="name"
              :selected="isCurrentCell(name)"
              @click="select(name, 0)"
            >
              {{ cellDesc(name) }}
            </v-chip>
          </div>

          <!-- SL / hierarchy selector (unchanged) -->
          <template v-else>
            <div v-for="(c, i) in selected" :key="i">
              {{ t(cellType(c)) }}:
              <v-chip v-for="(name, k) in cellNames(i)" :key="k" :selected="isSelected(name, i)" @click="select(name, i)">
                {{ cellDesc(name) }}
              </v-chip>
            </div>
            <div v-if="cellNames(last + 1).length">
              {{ t(cellType(selected[last], -1)) }}:
              <v-chip v-for="(name, i) in cellNames(last + 1)" :key="i" @click="select(name, last + 1)">
                {{ cellDesc(name) }}
              </v-chip>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { cellTypeName } from '@/global'
import { mapState } from 'vuex'
import { mapStateMutations } from '@/store'

console.log('[CellSelect] module loaded')

export default {
  data() {
    return {
      subcell: null,
      expanded: null,
    }
  },
  computed: {
    ...mapState('cell', ['item', 'cells']),
    userCells() {
      return this.$store.state.auth.userCells
    },
    selected: mapStateMutations('cell/selected'),
    last() {
      return this.selected.length - 1
    },
    hasChildren() {
      return !!(this.item.cells && this.item.cells.length)
    },
    showUserCells() {
      const show = this.userCells && this.userCells.length > 1
      console.log('[CellSelect] showUserCells:', show, 'userCells:', this.userCells)
      return show
    },
  },
  created() {
    console.log('[CellSelect] created - item.cells:', this.item.cells, 'userCells:', this.userCells)
  },
  watch: {
    userCells: {
      immediate: true,
      handler(val) {
        console.log('[CellSelect] userCells changed:', val)
      }
    }
  },
  methods: {
    cellDesc(cell) {
      return this.$store.getters['cell/cellDesc'](cell)
    },
    cellType(cell, delta) {
      return cellTypeName(cell, delta)
    },
    cellNames(level) {
      return level === 0 ? [this.selected[0].name] : this.selected[level - 1].cells || []
    },
    // cellsDesc(level) {
    //   const a = level === 0 ? [this.selected[0].name] : this.selected[level - 1].cells || []
    //   return a.map((cell) => this.$store.getters['cell/cellDesc'](cell))
    // },
    isSelected(name, i) {
      return this.selected[i].name === name && i === this.last
    },
    isCurrentCell(name) {
      return this.$store.getters['cell/selected'] === name
    },
    select(name, level) {
      const cell = this.cells[name]
      const a = this.selected.slice()
      a.splice(level, a.length, cell)
      this.$store.commit('cell/selected', a)
      this.$store.dispatch('assignment/bind', name)
      this.$store.dispatch('meeting/dates', name)
      this.$store.dispatch('meeting2/dates', name)
      this.$store.dispatch('meeting2/bindAssignments', name)
      this.expanded = null
    },
  },
}
</script>

<style lang="stylus">
#cell-select {
  box-shadow: unset;

  .v-expansion-panel__header {
    padding-left: 16px;
    padding-right: 16px;

    div {
      // height: 42px
      vertical-align: middle;
    }
  }
}

#cell-select {
  width: auto;
  display: flex;

  .label {
    span {
      height: 32px;
    }
  }

  .v-item-group {
    display: flex;
  }

  .v-messages {
    min-height: 0px;
  }

  .v-input__slot {
    margin-bottom: 0px;
  }
}

#cell-select .v-input__slot:after {
  width: 0px;
  border-width: 0px;
}

#cell-select {
  .v-input {
    margin-top: 0px;
    padding-top: 0px;
    max-width: 80px;
  }
}
</style>
